function Spinner({ message } : { message?: string }) {
    return (
        <div className="absolute inset-0 z-55 flex flex-col justify-center items-center bg-white rounded-2xl bg-opacity-50 dark:bg-black/10">
        <div className="w-12 h-12 mt-4 mb-4 rounded-full animate-spin border-y-2 border-solid border-gray-900 border-t-transparent dark:border-slate-200"></div>
        {message && <div className="text-lg font-bold text-gray-900">{message}</div>}
    </div>
    );
}

export default Spinner